import api from '../index.js'

const api_requests = {
    create: async (file, isbase64, name) => {
        var response = null
        if (typeof file === 'string') {
            if (isbase64 == null) {
                throw 'When create a resource from a string, please provide the isbase64 (bool) argument'
            }
            var payload = {
                filename: name,
                content: file,
                base64Encoded: isbase64
            }
            response = await api.post('/Resources/fromstring', payload)
            response.data.src = file
            response.data.file = null
        } else {
            var formData = new FormData()
            formData.append('file', file)
            var prom = api.post('/Resources', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            if (file.type == 'image/heic') {
                response = await prom
            } else {
                var base64 = await file.toBase64()
                response = await prom
                response.data.src = base64
            }
            response.data.file = file
        }
        return response.data
    },
    getUrl: (uuid) => {
        return `${api.defaults.baseURL}/Resources/${uuid}`
    },
    getImageUrl: (uuid) => {
        return `${api.defaults.baseURL}/Images/${uuid}`
    },
    getThumbnailUrl: (uuid) => {
        return `${api.defaults.baseURL}/Images/${uuid}/thumbnail`
    },
    get: (uuid) => {
        return {
            id: uuid,
            src: `${api.defaults.baseURL}/Resources/${uuid}`
        }
    },
    download: async (resource) => {
        try {
            api.download(`/resource/Resources/${resource.id}/download`, {
                filename: resource.filename
            })

            // var response = await api.get(`/resource/Resources/${resource.id}/download`, {
            //     responseType: 'blob'
            // })
            // const url = window.URL.createObjectURL(new Blob([response.data]))
            // const link = document.createElement('a')
            // link.href = url
            // link.setAttribute('download', resource.filename) //or any other extension
            // document.body.appendChild(link)
            // link.click()
            // document.body.removeChild(link)
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    getMeta: async (uuid) => {
        var response = await api.get(`/Resources/${uuid}/info`)
        return response.data
    },
    delete: async (uuid) => {
        var response = await api.delete(`/Resources/${uuid}`)
        return response.data
    }
}

export default api_requests
